import React from "react";
import { usePinMessageMutation } from "../api/chatApi";
import Toast from "../../../components/ToastNotification";
import { useSelector } from "react-redux";

const MessageOptions = ({ position, onClose, selectedMessage, setSelectContact, onOpenPinDurationModal, replyState }) => {
    const { session } = useSelector((state) => state.auth);
    const contactList = useSelector((state) => state.chat?.contacts);
    
    const {user_id, recipient, message_id, is_pinned, sender, contact, is_group} = selectedMessage;
    const fromMe = session?.client_id === sender;
    const [pinMessageApi] = usePinMessageMutation();

    const handleSelectContact = () => {
        const contact = contactList?.find(con => con.wa_id === sender);
        if (!contact) {
            setSelectContact({ 
                wa_id: sender, 
                name: sender.split('@')[0]
            });
        } else setSelectContact(contact);
        
    }

    const handlePinDuration = async () => {
        if (!is_pinned) {
            onOpenPinDurationModal();
            return;
        } else {
            try {
                const res = await pinMessageApi({
                    user_id, 
                    remote_jid: recipient, 
                    message_key: message_id, 
                    type: is_pinned ? "UNPIN_FOR_ALL" : "PIN_FOR_ALL"
                }).unwrap();
    
                Toast.success(res.message);
                onClose();
            } catch (error) {
                Toast.error(error.data.message)
            }
        }
    }

    return (
        <div 
            className="msg-menu" 
            style={{ top: position.y, left: fromMe ? position.x - 180 : position.x  }}
            onClick={onClose}
        >
        <div className="option" onClick={replyState}>
            <div className="pinned-section-icon">
                <img className="reply-img" src="/reply.png" alt="" />
                <p>Reply</p>
            </div>
        </div>
        <div className="option" onClick={handlePinDuration}>
            <div className='pinned-section-icon '>
                <img className='pin-img' src={is_pinned ? "/unpin.png" : "/pin.png"} alt=''/>
                <p className="pin-label">{is_pinned ? "Unpin" : "Pin"}</p>
            </div>
        </div>
        {!fromMe && is_group && (
            <div className="option" onClick={handleSelectContact}>
            💬 Message {contact?.push_name || contact?.name || sender.split('@')[0]}
            </div>
        )}
        </div>
    );
}

export default MessageOptions;
